import React, { useRef } from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'

import Layout from '../components/Layout'
import Debug from '../components/Debug'
import HomeIntro from '../components/HomeIntro'
import HomeDirectory from '../components/HomeDirectory'
import HomeHero from '../components/HomeHero'
import Headline from '../components/Headline'
import Caption from '../components/Caption'
import Breadcrumbs from '../components/Breadcrumbs'
import Breadcrumb from '../components/Breadcrumb'
import Heading from '../components/Heading'
import Nav from '../components/Nav'
import PageHero from '../components/PageHero'

export default function IndexPage() {
  const data = useStaticQuery(graphql`
    query GetAllEvents {
      allSanityPromotion(sort: { fields: name, order: ASC }) {
        nodes {
          id
          name
          gatsbyPath(filePath: "/promotion/{SanityPromotion.slug__current}")
        }
      }
      allSanityYear(sort: { fields: name, order: ASC }) {
        nodes {
          id
          name
          gatsbyPath(filePath: "/year/{SanityYear.slug__current}")
        }
      }
      allSanityCollection(sort: { fields: name, order: ASC }) {
        nodes {
          id
          name
          gatsbyPath(filePath: "/collection/{SanityCollection.slug__current}")
          promotions {
            abbreviation
          }
        }
      }
      allSanityEvent(sort: { fields: date, order: ASC }) {
        nodes {
          id
          name
          slug {
            current
          }
          date(formatString: "MMMM D, YYYY")
          promotion {
            abbreviation
            gatsbyPath(filePath: "/promotion/{SanityPromotion.slug__current}")
          }
          featuredImage {
            asset {
              gatsbyImageData(placeholder: BLURRED)
            }
            hotspot {
              y
              x
              width
              height
            }
            caption
            alt
          }
        }
      }
    }
  `)

  const events = data?.allSanityEvent?.nodes ?? {}
  const years = data?.allSanityYear?.nodes ?? {}
  const collections = data?.allSanityCollection?.nodes ?? {}
  const promotions = data?.allSanityPromotion?.nodes ?? {}

  const nwawcwCollections = collections.filter((collection) =>
    collection.promotions.some(
      (promotion) =>
        promotion.abbreviation === 'NWA' || promotion.abbreviation === 'WCW',
    ),
  )

  const wwfCollections = collections.filter((collection) =>
    collection.promotions.some((promotion) => promotion.abbreviation === 'WWF'),
  )

  const randomEvent = useRef(events[Math.floor(Math.random() * events.length)])

  return (
    <Layout modifier="home">
      {/* <HomeHero featuredImage={randomEvent.current.featuredImage}>
        <Headline>{randomEvent.current.name}</Headline>
        <Caption>{randomEvent.current.featuredImage.caption}.</Caption>
        <Breadcrumbs>
          <Breadcrumb>
            <Link
              className="mod-underline"
              to={`/event/${randomEvent.current.slug.current}`}
            >
              View Featured Event
            </Link>
          </Breadcrumb>
        </Breadcrumbs>
      </HomeHero> */}
      <PageHero>
        <Headline>Retro Wrestling Archive</Headline>
        <Caption>
          {events[0].date.split(', ')[1]}-
          {events[events.length - 1].date.split(', ')[1]} • {events.length}
          {` `}
          {events.length > 1 ? `Events` : `Event`}
        </Caption>
      </PageHero>
      <HomeIntro />
      <HomeDirectory>
        <Nav
          promotions={promotions}
          years={years}
          nwawcwCollections={nwawcwCollections}
          wwfCollections={wwfCollections}
          events={events}
        />
      </HomeDirectory>
    </Layout>
  )
}
